/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { DocumentTextIcon, ChatIcon, PencilIcon, TemplateIcon, SparklesIcon } from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CardHeadingTabs({ tabs, selectedTab, onSelect }) {
  // Default tabs as fallback if none are provided
  const defaultTabs = [
    { name: "Create", icon: SparklesIcon },
    { name: "Summary", icon: ChatIcon },
    { name: "MindMap", icon: TemplateIcon },
    { name: "Transcript", icon: DocumentTextIcon },
    { name: "Notes", icon: PencilIcon },
  ];

  // Use provided tabs or defaults
  const tabsToRender = tabs || defaultTabs;

  return (
    <div>
      <div className="block">
        <div>
          <nav 
            className="flex justify-center sm:justify-start overflow-x-auto overflow-y-hidden scrollbar-hide" 
            aria-label="Section navigation" // More descriptive label for the navigation region
          >
            {tabsToRender.map((tab) => {
              const isSelected = tab.name === selectedTab;
              
              return (
                <button
                  key={tab.name}
                  onClick={() => onSelect(tab.name)}
                  aria-label={tab.name} // Ensures accessible name when text is hidden
                  className={classNames(
                    isSelected 
                      ? "text-primary-600 border-primary-600" 
                      : "text-neutral-500 border-transparent hover:text-neutral-700 hover:border-neutral-300",
                    "group inline-flex items-center py-2 px-2 border-b-2 text-sm font-medium whitespace-nowrap flex-shrink-0"
                  )}
                  aria-current={isSelected ? "page" : undefined}
                  title={tab.name} // Retained for tooltip functionality
                >
                  <tab.icon
                    className={classNames(
                      isSelected ? "text-primary-600" : "text-neutral-400 group-hover:text-neutral-600",
                      "h-5 w-5 transition-colors duration-200 ease-in-out"
                    )}
                    aria-hidden="true"
                  />
                  <span className="hidden sm:inline sm:ml-1 text-xs">{tab.name}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}
